import React, { useRef, useEffect } from 'react';
import { gameVolumeState } from '@/components/features/casino/crash/state';
import { useAtomValue } from 'jotai';
import {
  onPlayBetSound,
  onPlaySpinSound,
  onPlayTimeUpSound,
  onPlayWinSound,
  onPlayRushBgSound,
  onStopSpinSound,
  onStopRushBgSound,
} from './sound-event';
import { usePageVisibility } from '@/hooks/usePageVisibility';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';

export default function BgSoundManage() {
  const bgAudioRef = useRef<HTMLAudioElement>(null);
  const betAudioRef = useRef<HTMLAudioElement>(null);
  const spinAudioRef = useRef<HTMLAudioElement>(null);
  const timeUpAudioRef = useRef<HTMLAudioElement>(null);
  const winAudioRef = useRef<HTMLAudioElement>(null);
  const isPageActive = usePageVisibility();
  const globalVolume = useAtomValue(gameVolumeState);
  const setVolume = () => {
    if (!bgAudioRef.current) return;
    const volume = globalVolume / 100;
    const muted = volume === 0;
    bgAudioRef.current.volume = volume;
    betAudioRef.current.volume = volume;
    spinAudioRef.current.volume = volume;
    timeUpAudioRef.current.volume = volume;
    winAudioRef.current.volume = volume;

    bgAudioRef.current.muted = muted;
    betAudioRef.current.muted = muted;
    spinAudioRef.current.muted = muted;
    timeUpAudioRef.current.muted = muted;
    winAudioRef.current.muted = muted;
  };
  useEffect(() => {
    setVolume();
  }, [globalVolume]);

  useEffect(() => {
    if (!isPageActive) {
      stop();
    } else {
      playRushBgSound();
    }
  }, [isPageActive]);

  useEffect(() => {
    document.addEventListener('mouseenter', playRushBgSound);
    document.addEventListener('touchstart', playRushBgSound);
    return () => {
      document.removeEventListener('mouseenter', playRushBgSound);
      document.removeEventListener('touchstart', playRushBgSound);
    };
  }, []);

  const stop = () => {
    try {
      bgAudioRef.current?.pause();
    } catch (e) {
      console.log(e);
    }
  };

  const playRushBgSound = () => {
    if (globalVolume === 0) return;
    if (bgAudioRef.current?.paused) {
      bgAudioRef.current?.play();
    }
  };

  useEffect(() => {
    setVolume();
    stop();
    onPlayBetSound(() => {
      if (globalVolume === 0) return;
      betAudioRef.current?.play();
    });
    onPlaySpinSound(() => {
      if (globalVolume === 0) return;
      if (spinAudioRef.current) {
        spinAudioRef.current.currentTime = 0;
      }
      spinAudioRef.current?.play();
    });
    onPlayTimeUpSound(() => {
      if (globalVolume === 0) return;
      timeUpAudioRef.current?.play();
    });
    onPlayWinSound(() => {
      if (globalVolume === 0) return;
      winAudioRef.current?.play();
    });
    onPlayRushBgSound(() => {
      playRushBgSound();
    });
    onStopSpinSound(() => {
      if (globalVolume === 0) return;
      spinAudioRef.current?.pause();
    });
    onStopRushBgSound(() => {
      stop();
    });
    return () => {
      stop();
    };
  }, []);

  const router = useRouter();
  const { debug } = router.query;

  const controls = typeof debug !== 'undefined';
  return (
    <>
      {typeof debug !== 'undefined' && (
        <Box
          className={'bg-sound-manage'}
          sx={{
            position: 'fixed',
            top: 70,
            right: 20,
            zIndex: 9999,
            background: 'rgba(0,0,0,1)',
          }}
        >
          globalVolume:{globalVolume}
        </Box>
      )}
      <audio
        ref={bgAudioRef}
        controls={controls}
        loop
        src={'/audios/rush/background.mp3'}
      ></audio>
      <audio
        ref={betAudioRef}
        controls={controls}
        src={'/audios/rush/bet.mp3'}
      ></audio>
      <audio
        ref={spinAudioRef}
        controls={controls}
        src={'/audios/rush/spin.mp3'}
      ></audio>
      <audio
        ref={timeUpAudioRef}
        controls={controls}
        src={'/audios/rush/timesup.mp3'}
      ></audio>
      <audio
        ref={winAudioRef}
        controls={controls}
        src={'/audios/rush/win.mp3'}
      ></audio>
    </>
  );
}
